// No navegador não há agenda do aparelho: quem sincroniza com o Google é o app do celular.
export type Agenda = { id: string; titulo: string; conta: string; cor: string; google: boolean; editavel: boolean };
export type Resultado = { novas: number; atualizadas: number; enviadas: number; removidas: number; erro?: string };
export const temPermissao = async () => false;
export const pedirPermissao = async () => false;
export const listarAgendas = async (): Promise<Agenda[]> => [];
export const souOSincronizador = async (_cfg?: unknown) => false;
export const sincronizarAgenda = async (): Promise<Resultado | null> => null;
export const assinatura = (_c: unknown) => '';
import { setDoc } from '../store/store';
export function desligarAgenda(apagarImportadas: boolean) {
  setDoc('planner', d => ({ ...d, tasks: d.tasks
    .filter(x => !(apagarImportadas && x.gcal?.origem === 'google'))
    .map(x => (x.gcal ? { ...x, gcal: undefined } : x)) }));
  setDoc('ajustes', d => ({ ...d, gcal: null, gcalApagar: [] }));
}
